// Remembers the page a logged-out visitor was trying to open (e.g. the
// "salary paid" email button → /userprofile/salary?year=&month=) so the login
// page can send them straight back after signing in.
//
// Deliberately narrow: only personal User-View pages are remembered, and a
// saved link is honored only when it belongs to the signed-in role's own
// shell — anything else falls back to the normal role home page.

const KEY = "postLoginRedirect";
const MAX_AGE_MS = 30 * 60 * 1000; // a stale link from an old tab is ignored

const SHELL_BY_ROLE = {
  user: "/userprofile/",
  manager: "/userprofilemanager/",
  admin: "/userprofileadmin/",
};

const isPersonalPath = (path) =>
  Object.values(SHELL_BY_ROLE).some((prefix) => String(path).startsWith(prefix));

export function rememberPostLoginRedirect(path) {
  try {
    if (!path || !isPersonalPath(path)) return;
    sessionStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch (_) {
    /* storage unavailable — login just uses the default page */
  }
}

export function consumePostLoginRedirect(role) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const { path, at } = JSON.parse(raw);
    const prefix = SHELL_BY_ROLE[String(role || "").toLowerCase()];
    if (!prefix || typeof path !== "string" || !path.startsWith(prefix)) return null;
    if (!at || Date.now() - at > MAX_AGE_MS) return null;
    return path;
  } catch (_) {
    return null;
  }
}
